export default "__VITE_ASSET__CarLfCFC__"